/*
 Плагин для определения хоста приложения, с дальнейшим прокидыванием в nuxt
 Нужен для удобного доступа к хосту приложения в pageMeta и middleware
*/
export default defineNuxtPlugin({
  name: 'initHost',
  setup({ ssrContext }) {
    let host: string

    if (import.meta.server) {
      const ssrHost = ssrContext?.event?.node?.req?.headers?.host || ''

      if (!ssrHost) {
        throw createError({
          statusCode: 500,
          message: 'Не удалось определить host запроса',
        })
      }

      host = ssrHost
    } else {
      host = window.location.host
    }

    return {
      provide: {
        host,
      },
    }
  },
})
